import {mainQuery} from '@github-ui/react-core/future/main-query'
import {copilotAgentsAppBuilder} from '../../config/app-builder'
import type {CopilotAgentsSpacesPayload} from '../../types/copilot-agents-spaces-payload'

export function createCopilotAgentsNewSpaceRoute(path: string) {
  return copilotAgentsAppBuilder.createQueryRouteConfig('copilotAgentsNewSpaceRoute', {
    path,
    queries: [mainQuery<CopilotAgentsSpacesPayload>()],
  })
}

export const copilotAgentsNewSpaceRoute = createCopilotAgentsNewSpaceRoute('/copilot/agents/spaces/new')
export const canonicalCopilotAgentsNewSpaceRoute = createCopilotAgentsNewSpaceRoute('/copilot/spaces/new')
